import React from 'react';
import PropTypes from 'prop-types';
import { buildDefaultAltTag } from '../../../lib/helpers';
import { Link } from '@paypalcorp/pp-react';

// Parser for the details footer
export const detailsFooterContentParser = (detailsContent = {}) => {
  let buffData = {};
  try {
    buffData = JSON.parse(detailsContent);
  } catch (error) {
    buffData = null;
  }

  if (!buffData) {
    return buffData;
  }

  const linkItemValues = Object.keys(buffData).map(key => buffData[key]);
  let linkItemValuesPair = [];
  if (linkItemValues.length > 0) {
    const splitTwoSections = Math.ceil(linkItemValues.length / 2);
    const linkItemSectionCenter = linkItemValues.slice(0, splitTwoSections);
    const linkItemSectionRight = linkItemValues.slice(
      splitTwoSections,
      linkItemValues.length
    );
    linkItemValuesPair = [linkItemSectionCenter, linkItemSectionRight];
  }
  return linkItemValuesPair;
};

export const LeftColumnSection = props => {
  const { questionsLabel, helpLabel, handleClickFPTI, subtitleLink } = props;

  return (
    <div className="details-sections">
      <div className="left-section">
        <h2 className="question-label">{questionsLabel}</h2>
        <div className="details-footer-links-style font-size-p">
          <p
            onClick={e =>
              e.target.tagName === 'A' &&
              e.target.getAttribute('data-fptilinkname')
                ? handleClickFPTI(e.target.getAttribute('data-fptilinkname'))
                : {}
            }
            dangerouslySetInnerHTML={{ __html: helpLabel }}
            role="presentation"
          ></p>
          <Link
            href={subtitleLink.subtitleLinkUrl}
            onClick={() =>
              subtitleLink.fptiLinkName
                ? handleClickFPTI(subtitleLink.fptiLinkName)
                : {}
            }
          >
            {subtitleLink.subtitleLinkText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export const LinksColumnSection = props => {
  const { handleClickFPTI, linkItems, toolName } = props;

  return (
    <div className="details-sections details-sections-right">
      {linkItems.map(footerLink => {
        const alt =
          footerLink.alt || buildDefaultAltTag(toolName, footerLink.icon);

        return (
          <div
            key={`footer-link-${footerLink.fptiLinkName}`}
            onClick={() =>
              footerLink.fptiLinkName
                ? handleClickFPTI(footerLink.fptiLinkName)
                : {}
            }
            role="presentation"
            className="details-sections-links-data"
          >
            <img src={footerLink.icon} alt={alt} />
            <p className="details-footer-links-style font-size-p">
              <Link href={footerLink.linkUrl}>{footerLink.linkText}</Link>
            </p>
          </div>
        );
      })}
    </div>
  );
};

LeftColumnSection.propTypes = {
  handleClickFPTI: PropTypes.func,
  leftColumnData: PropTypes.object,
  questionsLabel: PropTypes.string,
  helpLabel: PropTypes.string,
  subtitleLink: PropTypes.string
};

LinksColumnSection.propTypes = {
  linkItems: PropTypes.array,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string
};

export default {
  detailsFooterContentParser,
  LinksColumnSection,
  LeftColumnSection
};
